import { useTranslation } from 'react-i18next';

export const CareerButton = ({ label, onClick, disabled }) => {
  const [t] = useTranslation();
  const buttonTitle = t('career_overview_page:views.create_new_tooltip');

  return (
    <div className="linkbutton-widget">
      <button
        alt={buttonTitle}
        title={buttonTitle}
        disabled={disabled}
        onClick={onClick}
        className="link-button large invers button-career"
      >
        {label}
      </button>
    </div>
  );
};
CareerButton.defaultProps = {
  disabled: false,
};
